<template>
    <div class="files-container">
        <FileCard
            v-for="file in files"
            :key="file._id"
            :file="file"
            :selected="isFileSelected(file)"
            @doubleClick="handleDoubleClick"
            @delete="handleDelete"
            @toggleSelection="$emit('fileSelect', $event)"
        />
    </div>
</template>

<script>
import Vue from "vue";
import FileCard from "./FileCard.vue";

export default Vue.extend({
    name: "FilesCardView",
    components: {
        FileCard,
    },
    props: {
        files: {
            type: Array,
            default: () => [],
        },
        selectionMode: {
            type: Boolean,
            default: false
        },
        selectedFiles: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleDelete(file) {
            this.$emit("delete", file);
        },
        handleDoubleClick(file) {
            console.log(`[DRIVE] File double clicked: ${file.name}`);
            if (file.isFolder) {
                this.$emit("folderDoubleClick", file._id);
            }
        },
        isFileSelected(file) {
            return this.selectedFiles.some(f => f._id === file._id);
        },
        handleFileClick(file) {
            if (this.selectionMode) {
                this.$emit('fileSelect', file);
            }
        }
    },
});
</script>

<style scoped lang="scss">
.files-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 20px;
}
</style>
